// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body--NgvmAsX4{position:relative;flex:1;min-height:0}.chat--Dd_Y5vKy{background:rgba(227,228,229,0.4);border:1px solid rgba(0,0,0,0.1);border-radius:8px;padding:16px 20px;height:100%;overflow-y:auto}.messages--XFimmqyO{width:100%;margin:0 auto}.message--R4_9LFJq + .message--R4_9LFJq{margin-top:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `body--NgvmAsX4`,
	"chat": `chat--Dd_Y5vKy`,
	"messages": `messages--XFimmqyO`,
	"message": `message--R4_9LFJq`
};
export default ___CSS_LOADER_EXPORT___;
